import moment from 'moment';

export const getSubscriptionList = payload => ({
    ...payload,
    page: payload.page,
    order_by: payload.orderBy,
    order_direction: payload.direction?.toUpperCase(),
    enrich_with: payload.enrichWith,
    filter_roles: payload.role === 'all' ? undefined : payload.role,
    filter_minAdmissionFee: payload.minAdmissionFee,
    filter_maxAdmissionFee: payload.maxAdmissionFee,
    filter_subscriptionStatus: payload.subscriptionStatus,
    filter_subscriptionCreatedBy: payload.dist,
    filter_emails: payload.email?.toLowerCase(),
    filter_search: payload.keyword,
    filter_companyId: payload.companyId,
    filter_emailConfirmed: payload.emailConfirmed,
    filter_investmentFunds: payload.product,
    filter_alertTypes: payload.alertTypes === 'all' ? undefined : payload.alertTypes,
    filter_pendingActivation: payload.pendingActivation,
    filter_pendingServicerValidation: payload.pendingServicerValidation,
    filter_pendingCIFValidation: payload.pendingCIFValidation,
    filter_investmentFundEligible: payload.investmentFundEligible,
    filter_pendingSGPSignature: payload.pendingSGPSignature,
    filter_pendingTransfer: payload.pendingTransfer,
    filter_transferredConfirmed: payload.transferred,
    filter_transferred_0_3: payload.transferred03,
    filter_transferred_3_7: payload.transferred37,
    filter_transferred_7_30: payload.transferred730,
    filter_transferred_30_plus: payload.transferred30plus,
    filter_activity_0_3: payload.activity_0_3,
    filter_activity_3_7: payload.activity_3_7,
    filter_activity_7_30: payload.activity_7_30,
    filter_activity_30_plus: payload.activity_30_plus,
    filter_rib_document_changes: payload.ribChanges,
    filter_indirectSubscriptions: payload.indirectSubscriptions,
    filter_shareSubcategories: payload.subcategory,
    filter_investingSumMin: payload.minSum === '' ? undefined : payload.minSum,
    filter_investingSumMax: !payload.maxSum ? undefined : payload.maxSum,
    filter_accountCreationFromDate: payload.issueDateStart || undefined,
    filter_accountCreationToDate: payload.issueDateEnd || undefined,
    filter_subscriptionFinishedFromDate: payload.entryDateStart || undefined,
    filter_subscriptionFinishedToDate: payload.entryDateEnd || undefined,
    filter_investorClassification:
        payload.investorClassification === 'all' ? undefined : payload.investorClassification,
    filter_subscriptionCreatedByTag: payload.tag || undefined,
    filter_bankingStatementStatus: payload.bankingStatementStatus,
    filter_fundSGPId: payload.fundSGPId || (payload.provider ? [payload.provider] : undefined),
    filter_promoterId: payload.promoter,
    per_page: payload.itemsPerPage,
});

export const transferSubscription = payload => ({
    distributorAdmissionFee: +payload.admissionFee,
    subscriptionId: payload.id,
});

export const newIndirectSubscription = (shareCategoryId, userId) => ({
    shareCategoryId,
    investorId: +userId,
});

export const addExternalSubscription = ({
    profile,
    role,
    investmentFund,
    bsDocument,
    bsSignatureDate,
    ...obj
}) => {
    const user = {
        email: obj.email,
        firstName: obj.firstName,
        lastName: obj.lastName,
        title: obj.title,
        phoneNumber: obj.phoneNumber,
        investorClassification: obj.investorClassification,
    };
    const investorProfile = {
        reportingCCEmails: JSON.stringify(obj.addresses),
        fundraisingCCEmails: JSON.stringify(obj.addresses),
        capitalAccountCCEmails: JSON.stringify(obj.addresses),
        subscriptionProcessCCEmails: JSON.stringify(obj.addresses),
    };
    const investmentCharacteristics = {
        investingSum: +obj.investingSum,
        admissionFee: +obj.admissionFee,
        shareSubcategory: `/api/share_subcategories/${obj.shareSubcategory}`,
    };
    const bankingStatement = { paymentMethod: obj.paymentMethod };
    const offsetMin = moment().utcOffset();

    const payload = {
        user,
        role: +role,
        investmentFund: +investmentFund,
        investorProfile,
        investmentCharacteristics,
        bankingStatement,
        finishedSubscriptionAt: new Date(bsSignatureDate.add(offsetMin, 'minute')),
        currentLocation: obj.currentAddress,
    };
    const formData = new FormData();
    formData.append('files[subscriptionForm]', bsDocument);

    if (obj.distributorUser) {
        payload.subscriptionDistributorUserId = obj.distributorUser;
    }

    if (obj.shareCategory) {
        payload.shareCategory = +obj.shareCategory;
    }

    if (profile === 'PM') {
        const investorCompany = {
            corporateName: obj.corporateName,
        };
        payload.investorCompany = investorCompany;
        payload.addressLocation = obj.currentAddress;
    }

    formData.append('body', JSON.stringify(payload));

    return formData;
};
